import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sheba-google-play-dark-icon',
  templateUrl: 'google-play-dark.svg',
  host: {
    class: 'contents'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GooglePlayDarkIcon { }
